import { Component, Input, EventEmitter, Output } from '@angular/core';
import { Badge } from '../models/badge.interface';
import { Settings } from 'src/app/app.settings.model';
import { AppSettings } from 'src/app/app.settings';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss']
})
export class BadgeComponent {
  _rtl = false;
  @Input('dataSource') badges: Badge[];
  @Input('color') color: string = 'white';
  @Input('Tcolor') Tcolor: string = '#989898';
  @Input('isTextRight') isTextRight: boolean = false;
  @Output() selectdBadge = new EventEmitter();
  @Input() warpContant: boolean = false;
  settings: Settings;
  constructor(private appSettings: AppSettings) {
    this.settings = this.appSettings.settings;
  }

  // bindColorStyle(color) {
  //    var cssClasses = "";
  //     if (color) {
  //         cssClasses = color
  //     }
  //     else {
  //         cssClasses = "#f2f2f2"
  //     }
  //     return cssClasses;
  // }

  selectBadge(id) {
    this.selectdBadge.emit(id);
  }
}
